import { Module, Modules, Router } from '@autoprog/core-client';

import C_AddQuotes from './js/controllers/AddQuotes';
import C_Quotes from './js/controllers/QuotesTabs';
import C_ViewQuotes from './js/controllers/ViewQuotes';

import T_AddQuotes from './tpl/addQuotes.html';
import T_Tabs from '@tpl/tabs.html';
import T_ViewQuotes from './tpl/viewQuotes.html';

import Navigation from '@libs/Navigation';
import NavigationMobile from '@libs/NavigationMobile';
import Notifications from '@modules/Apps/js/libs/Notifications';

import M_quotes_to_do from './js/modals/QuotesToDo/Information';

import CE_BrochureTab from './js/libs/customElement/BrochureTab';
import CE_GridQuote from './js/libs/customElement/GridQuote';
import CE_QuoteInformations from './js/libs/customElement/QuoteInformations';
import CE_QuoteOption from './js/libs/customElement/QuoteOption';
import CE_QuoteOptionReadonly from './js/libs/customElement/QuoteOptionReadonly';
import CE_QuotePrintOption from './js/libs/customElement/QuotePrintOption';
import CE_QuoteRelance from './js/libs/customElement/QuoteRelance';
import CE_RecapProductTab from './js/libs/customElement/RecapProductsTab';
import CE_RecapTab from './js/libs/customElement/RecapTab';
import CE_UpdateGroup from './js/libs/customElement/button-edit-aggrid/UpdateGroup';

import SettingsNotificationRegister from '@modules/Notifications/js/libs/SettingsNotificationRegister';
import SettingsRegister from '@modules/Settings/js/libs/SettingsRegister';

import C_SettingsQuote from './js/controllers/Settings.Quote';
import T_SettingsQuote from './tpl/settings.Quote.html';
class QuotesModule extends Module {
	public constructor(options: Record<string, any>) {
		super(options);

		CE_GridQuote.register();
		CE_RecapTab.register();
		CE_RecapProductTab.register();
		CE_QuoteInformations.register();
		CE_QuoteOption.register();
		CE_QuoteOptionReadonly.register();
		CE_QuotePrintOption.register();
		CE_QuoteRelance.register();
		CE_BrochureTab.register();
		CE_UpdateGroup.register();
	}

	public async preInit() {
		const navigation = Navigation.getInstance();
		navigation.addCategory({
			name: 'Documents',
			order: 100
		});
		navigation.addLink({
			order: 0,
			category: 'Documents',
			name: 'Devis / Devis à faire',
			type: 'module',
			module: 'quotes',
			permissions: ['QUOTES', 'QUOTES._FAVORITE', 'QUOTES._QUOTES_TO_DO'],
			icon: 'file-edit/line'
		});

		NavigationMobile.getInstance().addLink({
			icon: 'icon-solid-file-contract',
			name: 'Devis',
			order: 5,
			dataset: {
				link: 'quotes'
			}
		});

		const settingsNotificationRegister = SettingsNotificationRegister.getInstance();
		settingsNotificationRegister.addInput({
			text: 'Devis',
			select: [
				{
					text: 'Relance',
					name: 'quotes.relunch'
				}
			]
		}, 0);

		Notifications.addCategory(['quote', 'quote-relunch', 'quote-validate', 'quote-not-finish', 'quotes-to-do'], {
			textFilter: 'Devis',
			isFilter: true,
			icon: 'icon-solid-file-contract',
			action: async (item: { [key: string]: any }) => {
				if (['quote', 'quote-not-finish', 'quote-relunch'].includes(item.type) && item.data.id) {
					C_AddQuotes.open(item.data.id);
				}

				if (['quote-validate'].includes(item.type) && item.data.id) {
					C_AddQuotes.open(item.data.id, { notification: item._id });
				}

				if (['quotes-to-do'].includes(item.type) && item.data.id) {
					const data = await new M_quotes_to_do(item.data.id, 'notification').open();

					if (data === 'notification') {
						await Notifications.closeNotification(item._id);
					}
				}
			}
		});

		const settingsRegister = SettingsRegister.getInstance();
		settingsRegister.addCategory({
			id: 'general',
			order: 0
		});

		settingsRegister.addLink({
			id: 'apps',
			Controller: C_SettingsQuote,
			tpl: T_SettingsQuote,
			icon: 'file-edit/line',
			order: 10,
			category: 'general',
			name: 'Devis',
			permission: 'QUOTES.DEFAULT_SETTINGS'
		});
	}

	public async init() {
		const router = Router.getInstance();

		router.addRoute({
			url: '/module/quotes/:tabs',
			controller: C_Quotes as any,
			tpl: T_Tabs,
			requireValidUser: true,
			permission: 'QUOTES.SHOW || QUOTES._QUOTES_TO_DO.SHOW || QUOTES._FAVORITE.SHOW'
		});

		router.addRoute({
			url: '/module/quotes',
			controller: C_Quotes as any,
			tpl: T_Tabs,
			requireValidUser: true,
			permission: 'QUOTES.SHOW || QUOTES._QUOTES_TO_DO.SHOW || QUOTES._FAVORITE.SHOW'
		});

		router.addRoute({
			url: '/module/quote/view',
			controller: C_ViewQuotes as any,
			tpl: T_ViewQuotes,
			requireValidUser: true,
			permission: 'QUOTES.OPEN'
		});

		//Page de création d'un devis
		router.addRoute({
			url: '/module/quote/add',
			controller: C_AddQuotes as any,
			tpl: T_AddQuotes,
			requireValidUser: true,
			permission: 'QUOTES.OPEN'
		});
	}

	public async postInit() {
	}
}

Modules.registerModule('Devis', QuotesModule);
